import { render, staticRenderFns } from "./projectInit.vue?vue&type=template&id=526c8acf&scoped=true"
import script from "./projectInit.vue?vue&type=script&lang=js"
export * from "./projectInit.vue?vue&type=script&lang=js"
import style0 from "./projectInit.vue?vue&type=style&index=0&id=526c8acf&prod&scoped=true&lang=css"
import style1 from "./projectInit.vue?vue&type=style&index=1&id=526c8acf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c8acf",
  null
  
)

export default component.exports